<template>
        <router-view></router-view>
</template>

<script>
    export default {
        name: "HomeView"
    }
</script>

<style scoped>

</style>